import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Blank_ScreenContext } from "../blank/blank-context";

declare let window: any;

export interface IAnaSayfa_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IAnaSayfa_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  SetLanguage: string;
  SetLanguage_dummy: string;
  GetLanguage: string;
  GetLanguage_dummy: string;
  GetParametreler: any[];
  GetParametreler_dummy: any[];
  GetKullanici: any[];
  GetKullanici_dummy: any[];
  ReadFromSessionStorage: string;
  ReadFromSessionStorage_dummy: string;
  GetCariBilgileri: any[];
  GetCariBilgileri_dummy: any[];
  GetToplamTeklifSepeti: any[];
  GetToplamTeklifSepeti_dummy: any[];
  GetToplamSiparisSepetUrunSayisi: any[];
  GetToplamSiparisSepetUrunSayisi_dummy: any[];
  GetYeniUrunler: any[];
  GetYeniUrunler_dummy: any[];
  GetCariParaBirimi: any[];
  GetCariParaBirimi_dummy: any[];
  Top5SiparisDesc: any[];
  Top5SiparisDesc_dummy: any[];
  Top5Teklif: any[];
  Top5Teklif_dummy: any[];
  ToplamSiparisSayisi: any[];
  ToplamSiparisSayisi_dummy: any[];
  ToplamTeklifSayisi: any[];
  ToplamTeklifSayisi_dummy: any[];
  ToplamRevizeBekleyenTeklif: any[];
  ToplamRevizeBekleyenTeklif_dummy: any[];
  ToplamOnayBekleyenTeklifler: any[];
  ToplamOnayBekleyenTeklifler_dummy: any[];
  SepetteBekleyen5Stok: any[];
  SepetteBekleyen5Stok_dummy: any[];
  CariEkstreToplam: any[];
  CariEkstreToplam_dummy: any[];
  GetKampanyaliUrunler: any[];
  GetKampanyaliUrunler_dummy: any[];
  Notify: boolean;
  Notify_dummy: boolean;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  isComp692983Visible: "visible" | "hidden";
  isComp913183Visible: "visible" | "hidden";
  isComp583090Visible: "visible" | "hidden";
  isComp469352Visible: "visible" | "hidden";
  isComp185849Visible: "visible" | "hidden";
  isComp9628Visible: "visible" | "hidden";
  isComp610456Visible: "visible" | "hidden";
  isComp741887Visible: "visible" | "hidden";
  isComp487899Visible: "visible" | "hidden";
}

export class AnaSayfa_ScreenBase extends React.PureComponent<
  IAnaSayfa_ScreenProps,
  any
> {
  static contextType = Blank_ScreenContext;
  declare context: React.ContextType<typeof Blank_ScreenContext>;
  anasayfa_745370_value_kuikaCarouselRef: React.RefObject<any>;
  anasayfa_104013_value_kuikaTableRef: React.RefObject<any>;
  anasayfa_530498_value_kuikaTableRef: React.RefObject<any>;
  anasayfa_87951_value_kuikaTableRef: React.RefObject<any>;
  anasayfa_34385_value_kuikaGalleryViewRef: React.RefObject<any>;
  ml = [
    {
      Id: "e6553d05-98ae-4ab8-be91-cc851f894a0b",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 317000,
          PropertyName: "placeholder",
          Value:
            "VADEN NUMBER, OEM NUMBER, PRODUCT NUMBER, PRODUCT NAME, BRAND, MODEL, VEHICLE",
          TagName: "TextInput3_placeholder",
        },
        {
          Id: 733891,
          PropertyName: "label",
          Value: "Turkish",
          TagName: "ContentMenuItem4_2_label",
        },
        {
          Id: 117303,
          PropertyName: "label",
          Value: "English",
          TagName: "ContentMenuItem4_3_label",
        },
        {
          Id: 404060,
          PropertyName: "label",
          Value: "PROFILE",
          TagName: "ContentMenuItem4_5_label",
        },
        {
          Id: 294677,
          PropertyName: "value",
          Value: "VIEW ALL",
          TagName: "Label24_value",
        },
        {
          Id: 134673,
          PropertyName: "value",
          Value: "VIEW ALL",
          TagName: "Label47_value",
        },
        {
          Id: 105990,
          PropertyName: "value",
          Value: "LAST ORDERS",
          TagName: "Label17_2_value",
        },
        {
          Id: 372672,
          PropertyName: "value",
          Value: "LIST LAST 5 ORDERS",
          TagName: "Label53_value",
        },
        {
          Id: 776288,
          PropertyName: "value",
          Value: "PRODUCTS WAITING IN CART ",
          TagName: "Label17_3_value",
        },
        {
          Id: 6470,
          PropertyName: "value",
          Value: "5 PRODUCTS WAITING IN YOUR CART ARE LISTED",
          TagName: "Label54_value",
        },
        {
          Id: 769147,
          PropertyName: "value",
          Value: "LATEST OFFERS",
          TagName: "Label17_5_value",
        },
        {
          Id: 880811,
          PropertyName: "value",
          Value: "LIST LAST 5 OFFERS",
          TagName: "Label55_value",
        },
        {
          Id: 107477,
          PropertyName: "value",
          Value: "TOTAL ORDER",
          TagName: "Label5_value",
        },
        {
          Id: 522785,
          PropertyName: "value",
          Value: "YOUR CURRENT BALANCE",
          TagName: "Label6_value",
        },
        {
          Id: 448502,
          PropertyName: "title",
          Value: "DATE",
          TagName: "TableTemplateColumn3_0_title",
        },
        {
          Id: 283195,
          PropertyName: "title",
          Value: "NO",
          TagName: "TableTemplateColumn3_2_title",
        },
        {
          Id: 985889,
          PropertyName: "title",
          Value: "AMOUNT",
          TagName: "TableTemplateColumn3_3_title",
        },
        {
          Id: 984470,
          PropertyName: "title",
          Value: "STATUS",
          TagName: "TableTemplateColumn3_1_title",
        },
        {
          Id: 635112,
          PropertyName: "title",
          Value: "PROCESSES",
          TagName: "TableTemplateColumn3_4_title",
        },
        {
          Id: 611468,
          PropertyName: "title",
          Value: "ADDED DATE",
          TagName: "TableTemplateColumn3_9_title",
        },
        {
          Id: 545685,
          PropertyName: "title",
          Value: "DATE",
          TagName: "TableTemplateColumn3_5_title",
        },
        {
          Id: 27018,
          PropertyName: "title",
          Value: "NO",
          TagName: "TableTemplateColumn3_6_title",
        },
        {
          Id: 840302,
          PropertyName: "title",
          Value: "STOCK NAME",
          TagName: "TableTemplateColumn3_8_title",
        },
        {
          Id: 49717,
          PropertyName: "value",
          Value: "VIEW ALL",
          TagName: "Label63_value",
        },
        {
          Id: 941190,
          PropertyName: "value",
          Value: "CHECK ALL ORDERS",
          TagName: "Label5_4_value",
        },
        {
          Id: 989658,
          PropertyName: "value",
          Value: "MORE DETAILS",
          TagName: "Label5_6_value",
        },
        {
          Id: 829135,
          PropertyName: "value",
          Value: "NTR PRODUCTS",
          TagName: "Label17_4_value",
        },
        {
          Id: 169963,
          PropertyName: "value",
          Value: "LIST NTR PRODUCTS",
          TagName: "Label64_value",
        },
        {
          Id: 185849,
          PropertyName: "value",
          Value: "CONFIRMED",
          TagName: "Label58_value",
        },
        {
          Id: 9628,
          PropertyName: "value",
          Value: "PENDING",
          TagName: "Label60_value",
        },
        {
          Id: 215100,
          PropertyName: "value",
          Value: "NO PROMOTIONAL PRODUCTS FOUND",
          TagName: "Label51_value",
        },
        {
          Id: 452726,
          PropertyName: "value",
          Value: "SPECIAL PROMOTIONAL PRODUCTS FOR YOU ARE LISTED HERE",
          TagName: "Label52_value",
        },
        {
          Id: 899822,
          PropertyName: "value",
          Value: "CAMPAIGN PRODUCTS ",
          TagName: "Label8_value",
        },
        {
          Id: 655743,
          PropertyName: "label",
          Value: "CHECK",
          TagName: "Button0_label",
        },
        {
          Id: 85946030,
          PropertyName: "d6cae65c-cef1-9a30-d855-453e36e1a0f4_notify",
          Value: "CANNOT ADD A PRODUCT TO YOUR CART WITHOUT A PRICE",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "cd8e66ca-d8dd-1a05-bdac-f63ba9f6777b",
      Name: "fr_FR",
      ShortName: "French",
      LanguagePhrases: [
        {
          Id: 317000,
          PropertyName: "placeholder",
          Value: "no Vaden, no OEM, nom du produit, marque, modèle, véhicule",
          TagName: "TextInput3_placeholder",
        },
        {
          Id: 733891,
          PropertyName: "label",
          Value: "Turkish",
          TagName: "ContentMenuItem4_2_label",
        },
        {
          Id: 117303,
          PropertyName: "label",
          Value: "English",
          TagName: "ContentMenuItem4_3_label",
        },
        {
          Id: 404060,
          PropertyName: "label",
          Value: "Profil",
          TagName: "ContentMenuItem4_5_label",
        },
        {
          Id: 294677,
          PropertyName: "value",
          Value: "Tout afficher",
          TagName: "Label24_value",
        },
        {
          Id: 134673,
          PropertyName: "value",
          Value: "Tout afficher",
          TagName: "Label47_value",
        },
        {
          Id: 105990,
          PropertyName: "value",
          Value: "Dernières commandes",
          TagName: "Label17_2_value",
        },
        {
          Id: 372672,
          PropertyName: "value",
          Value: "Les 5 dernières commandes sont répertoriées",
          TagName: "Label53_value",
        },
        {
          Id: 776288,
          PropertyName: "value",
          Value: "Produits en attente dans le panier",
          TagName: "Label17_3_value",
        },
        {
          Id: 6470,
          PropertyName: "value",
          Value: "5 produits en attente dans votre panier sont affichés.",
          TagName: "Label54_value",
        },
        {
          Id: 769147,
          PropertyName: "value",
          Value: "Dernières offres",
          TagName: "Label17_5_value",
        },
        {
          Id: 880811,
          PropertyName: "value",
          Value: "Les 5 dernières offres saisies sont répertoriées",
          TagName: "Label55_value",
        },
        {
          Id: 107477,
          PropertyName: "value",
          Value: "Commande totale",
          TagName: "Label5_value",
        },
        {
          Id: 522785,
          PropertyName: "value",
          Value: "Votre solde actuel",
          TagName: "Label6_value",
        },
        {
          Id: 448502,
          PropertyName: "title",
          Value: "Date",
          TagName: "TableTemplateColumn3_0_title",
        },
        {
          Id: 283195,
          PropertyName: "title",
          Value: "No",
          TagName: "TableTemplateColumn3_2_title",
        },
        {
          Id: 985889,
          PropertyName: "title",
          Value: "Montant",
          TagName: "TableTemplateColumn3_3_title",
        },
        {
          Id: 984470,
          PropertyName: "title",
          Value: "Statut",
          TagName: "TableTemplateColumn3_1_title",
        },
        {
          Id: 635112,
          PropertyName: "title",
          Value: "Opérations",
          TagName: "TableTemplateColumn3_4_title",
        },
        {
          Id: 611468,
          PropertyName: "title",
          Value: "Date d'ajout",
          TagName: "TableTemplateColumn3_9_title",
        },
        {
          Id: 545685,
          PropertyName: "title",
          Value: "Date",
          TagName: "TableTemplateColumn3_5_title",
        },
        {
          Id: 27018,
          PropertyName: "title",
          Value: "No",
          TagName: "TableTemplateColumn3_6_title",
        },
        {
          Id: 840302,
          PropertyName: "title",
          Value: "Nom de l'action",
          TagName: "TableTemplateColumn3_8_title",
        },
        {
          Id: 49717,
          PropertyName: "value",
          Value: "Tout afficher",
          TagName: "Label63_value",
        },
        {
          Id: 941190,
          PropertyName: "value",
          Value: "Consulter toutes les commandes",
          TagName: "Label5_4_value",
        },
        {
          Id: 989658,
          PropertyName: "value",
          Value: "Plus de détails",
          TagName: "Label5_6_value",
        },
        {
          Id: 829135,
          PropertyName: "value",
          Value: "Nouveaux produits ajoutés",
          TagName: "Label17_4_value",
        },
        {
          Id: 169963,
          PropertyName: "value",
          Value: "Les nouveaux produits ajoutés sont répertoriés",
          TagName: "Label64_value",
        },
        {
          Id: 185849,
          PropertyName: "value",
          Value: "Approuvé",
          TagName: "Label58_value",
        },
        {
          Id: 9628,
          PropertyName: "value",
          Value: "En attente",
          TagName: "Label60_value",
        },
        {
          Id: 215100,
          PropertyName: "value",
          Value: "Aucun produit promotionnel trouvé",
          TagName: "Label51_value",
        },
        {
          Id: 452726,
          PropertyName: "value",
          Value:
            "Vous trouverez ici une liste de produits promotionnels spécialement conçus pour vous.",
          TagName: "Label52_value",
        },
        {
          Id: 899822,
          PropertyName: "value",
          Value: "Produits de campagne",
          TagName: "Label8_value",
        },
        {
          Id: 655743,
          PropertyName: "label",
          Value: "Examinez",
          TagName: "Button0_label",
        },
        {
          Id: 82468789,
          PropertyName: "d6cae65c-cef1-9a30-d855-453e36e1a0f4_notify",
          Value:
            "Vous ne pouvez pas ajouter un produit sans prix à votre panier.",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "ef30cc19-66ab-ea0f-c492-2e57cb69ffd2",
      Name: "es_ES",
      ShortName: "Spanish",
      LanguagePhrases: [
        {
          Id: 317000,
          PropertyName: "placeholder",
          Value:
            "No.Vaden, No. oem, nombre del producto, marca, modelo, vehículo",
          TagName: "TextInput3_placeholder",
        },
        {
          Id: 733891,
          PropertyName: "label",
          Value: "Turkish",
          TagName: "ContentMenuItem4_2_label",
        },
        {
          Id: 117303,
          PropertyName: "label",
          Value: "English",
          TagName: "ContentMenuItem4_3_label",
        },
        {
          Id: 404060,
          PropertyName: "label",
          Value: "Perfil",
          TagName: "ContentMenuItem4_5_label",
        },
        {
          Id: 294677,
          PropertyName: "value",
          Value: "Ver todos",
          TagName: "Label24_value",
        },
        {
          Id: 134673,
          PropertyName: "value",
          Value: "Ver todos",
          TagName: "Label47_value",
        },
        {
          Id: 105990,
          PropertyName: "value",
          Value: "Pedidos recientes",
          TagName: "Label17_2_value",
        },
        {
          Id: 372672,
          PropertyName: "value",
          Value: "Ver los últimos 5 pedidos",
          TagName: "Label53_value",
        },
        {
          Id: 776288,
          PropertyName: "value",
          Value: "Productos en espera en el carrito",
          TagName: "Label17_3_value",
        },
        {
          Id: 6470,
          PropertyName: "value",
          Value: "Se muestran los 5 productos que esperan en su carrito.",
          TagName: "Label54_value",
        },
        {
          Id: 769147,
          PropertyName: "value",
          Value: "Últimas ofertas",
          TagName: "Label17_5_value",
        },
        {
          Id: 880811,
          PropertyName: "value",
          Value: "Ver las últimas 5 ocotizaciones",
          TagName: "Label55_value",
        },
        {
          Id: 107477,
          PropertyName: "value",
          Value: "Total de pedidos",
          TagName: "Label5_value",
        },
        {
          Id: 522785,
          PropertyName: "value",
          Value: "Su saldo actual",
          TagName: "Label6_value",
        },
        {
          Id: 448502,
          PropertyName: "title",
          Value: "Fecha",
          TagName: "TableTemplateColumn3_0_title",
        },
        {
          Id: 283195,
          PropertyName: "title",
          Value: "No",
          TagName: "TableTemplateColumn3_2_title",
        },
        {
          Id: 985889,
          PropertyName: "title",
          Value: "Valor",
          TagName: "TableTemplateColumn3_3_title",
        },
        {
          Id: 984470,
          PropertyName: "title",
          Value: "Estado",
          TagName: "TableTemplateColumn3_1_title",
        },
        {
          Id: 635112,
          PropertyName: "title",
          Value: "Transacciones",
          TagName: "TableTemplateColumn3_4_title",
        },
        {
          Id: 611468,
          PropertyName: "title",
          Value: "Fecha agregada",
          TagName: "TableTemplateColumn3_9_title",
        },
        {
          Id: 545685,
          PropertyName: "title",
          Value: "Fecha",
          TagName: "TableTemplateColumn3_5_title",
        },
        {
          Id: 27018,
          PropertyName: "title",
          Value: "No",
          TagName: "TableTemplateColumn3_6_title",
        },
        {
          Id: 840302,
          PropertyName: "title",
          Value: "Nombre de la acción",
          TagName: "TableTemplateColumn3_8_title",
        },
        {
          Id: 49717,
          PropertyName: "value",
          Value: "Ver todos",
          TagName: "Label63_value",
        },
        {
          Id: 941190,
          PropertyName: "value",
          Value: "Ver todos los pedidos",
          TagName: "Label5_4_value",
        },
        {
          Id: 989658,
          PropertyName: "value",
          Value: "Más detalles",
          TagName: "Label5_6_value",
        },
        {
          Id: 829135,
          PropertyName: "value",
          Value: "Productos recién añadidos",
          TagName: "Label17_4_value",
        },
        {
          Id: 169963,
          PropertyName: "value",
          Value: "Ver los productos más nuevos",
          TagName: "Label64_value",
        },
        {
          Id: 185849,
          PropertyName: "value",
          Value: "Aprobado",
          TagName: "Label58_value",
        },
        {
          Id: 9628,
          PropertyName: "value",
          Value: "Pendiente",
          TagName: "Label60_value",
        },
        {
          Id: 215100,
          PropertyName: "value",
          Value: "No se encontraron productos promocionales",
          TagName: "Label51_value",
        },
        {
          Id: 452726,
          PropertyName: "value",
          Value:
            "Aquí encontrará una lista de productos promocionales especiales para usted.",
          TagName: "Label52_value",
        },
        {
          Id: 899822,
          PropertyName: "value",
          Value: "Productos de campaña",
          TagName: "Label8_value",
        },
        {
          Id: 655743,
          PropertyName: "label",
          Value: "Ver",
          TagName: "Button0_label",
        },
        {
          Id: 38447599,
          PropertyName: "d6cae65c-cef1-9a30-d855-453e36e1a0f4_notify",
          Value: "No se puede añadir un producto al carrito sin un precio.",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "f1e96f18-81d9-6312-1ebe-139d61cd7180",
      Name: "tr_TR",
      ShortName: "Turkish",
      LanguagePhrases: [],
    },
    {
      Id: "1a55fd84-b5fb-48aa-a871-63efe1f7ac9d",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 317000,
          PropertyName: "placeholder",
          Value: "vaden no,  oem no,  ürün ismi,  marka,  model, araç",
        },
        { Id: 733891, PropertyName: "label", Value: "Turkish" },
        { Id: 117303, PropertyName: "label", Value: "English" },
        { Id: 852364, PropertyName: "label", Value: "Spanish" },
        { Id: 55820, PropertyName: "label", Value: "French" },
        { Id: 404060, PropertyName: "label", Value: "Profil" },
        { Id: 107477, PropertyName: "value", Value: "Toplam Sipariş" },
        { Id: 941190, PropertyName: "value", Value: "Tüm Siparişleri İncele" },
        { Id: 522785, PropertyName: "value", Value: "Güncel Bakiyeniz" },
        { Id: 989658, PropertyName: "value", Value: "Daha Fazla Detay" },
        {
          Id: 745370,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        { Id: 899822, PropertyName: "value", Value: "Kampanyalı Ürünler" },
        { Id: 149062, PropertyName: "value", Value: "[datafield:stok_kodu]" },
        {
          Id: 507198,
          PropertyName: "value",
          Value: "[datafield:adetbazlifiyataciklama]",
        },
        { Id: 554333, PropertyName: "label", Value: "İncele" },
        {
          Id: 215100,
          PropertyName: "value",
          Value: "Kampanyalı Ürün Bulunamadı",
        },
        {
          Id: 452726,
          PropertyName: "value",
          Value: "Size özel kampanyalı ürünler burada listelenir",
        },
        { Id: 579883, PropertyName: "value", Value: "Toplam Teklif" },
        { Id: 610546, PropertyName: "value", Value: "Tüm Teklifleri İncele" },
        { Id: 740991, PropertyName: "value", Value: "Revize Bekleyen Teklif" },
        { Id: 712762, PropertyName: "value", Value: "Tüm Teklifleri İncele" },
        { Id: 628432, PropertyName: "value", Value: "Onay Bekleyen Teklif" },
        { Id: 9826, PropertyName: "value", Value: "Tüm Teklifleri İncele" },
        { Id: 105990, PropertyName: "value", Value: "Son Siparişler" },
        {
          Id: 372672,
          PropertyName: "value",
          Value: "Son Girilen 5 Sipariş Listelenir",
        },
        { Id: 294677, PropertyName: "value", Value: "Tümünü Gör >" },
        { Id: 448502, PropertyName: "title", Value: "Tarih" },
        {
          Id: 125698,
          PropertyName: "value",
          Value: "[datafield:siparistarihi]",
        },
        { Id: 283195, PropertyName: "title", Value: "No" },
        {
          Id: 175313,
          PropertyName: "value",
          Value: "[datafield:siparisnumarasi]",
        },
        { Id: 985889, PropertyName: "title", Value: "Tutar" },
        { Id: 392132, PropertyName: "value", Value: "[datafield:parasembol]" },
        { Id: 465920, PropertyName: "value", Value: "[datafield:geneltoplam]" },
        { Id: 984470, PropertyName: "title", Value: "Durum" },
        { Id: 185849, PropertyName: "value", Value: "Onaylandı" },
        { Id: 9628, PropertyName: "value", Value: "Bekliyor" },
        { Id: 635112, PropertyName: "title", Value: "İşlemler" },
        {
          Id: 776288,
          PropertyName: "value",
          Value: "Sepette Bekleyen Ürünler",
        },
        {
          Id: 6470,
          PropertyName: "value",
          Value: "Sepetinizde Bekleyen 5 Ürün Listelenir",
        },
        { Id: 134673, PropertyName: "value", Value: "Tümünü Gör >" },
        { Id: 611468, PropertyName: "title", Value: "Ekleme Tarihi" },
        {
          Id: 337967,
          PropertyName: "value",
          Value: "[datafield:eklemetarihi]",
        },
        { Id: 545685, PropertyName: "title", Value: "Marka" },
        {
          Id: 241076,
          PropertyName: "value",
          Value: "[datafield:musterimarka]",
        },
        { Id: 27018, PropertyName: "title", Value: "Stok Kodu" },
        { Id: 765224, PropertyName: "value", Value: "[datafield:stokkodu]" },
        { Id: 840302, PropertyName: "title", Value: "Stok Adı" },
        { Id: 382192, PropertyName: "value", Value: "[datafield:stokadi]" },
        { Id: 769147, PropertyName: "value", Value: "Son Teklifler" },
        {
          Id: 880811,
          PropertyName: "value",
          Value: "Son Girilen 5 Teklif Listelenir",
        },
        { Id: 342678, PropertyName: "value", Value: "Tümünü Gör >" },
        { Id: 310097, PropertyName: "title", Value: "Tarih" },
        {
          Id: 198564,
          PropertyName: "value",
          Value: "[datafield:tekliftarihi]",
        },
        { Id: 281731, PropertyName: "title", Value: "No" },
        {
          Id: 443449,
          PropertyName: "value",
          Value: "[datafield:teklifnumarasi]",
        },
        { Id: 71014, PropertyName: "title", Value: "Tutar" },
        { Id: 951392, PropertyName: "value", Value: "[datafield:parasembol]" },
        { Id: 948978, PropertyName: "value", Value: "[datafield:geneltoplam]" },
        { Id: 755105, PropertyName: "title", Value: "Durum" },
        {
          Id: 272885,
          PropertyName: "value",
          Value: "[datafield:teklifdurumu]",
        },
        { Id: 230748, PropertyName: "title", Value: "İşlemler" },
        { Id: 829135, PropertyName: "value", Value: "Yeni Eklenen Ürünler" },
        {
          Id: 169963,
          PropertyName: "value",
          Value: "Yeni Eklenen Ürünler Listelenir",
        },
        { Id: 49717, PropertyName: "value", Value: "Tümünü Gör >" },
        {
          Id: 34385,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        { Id: 66368, PropertyName: "value", Value: "[datafield:fiyat]" },
        {
          Id: 741887,
          PropertyName: "title",
          Value: "[datafield:adetbazlifiyataciklama]",
        },
        { Id: 956743, PropertyName: "value", Value: "[datafield:stok_kodu]" },
        {
          Id: 289790,
          PropertyName: "value",
          Value: "[datafield:birlesmisstok]",
        },
        { Id: 655743, PropertyName: "label", Value: "İncele" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.anasayfa_317000_value_kuikaTextInputRef = React.createRef();
    this.anasayfa_745370_value_kuikaCarouselRef = React.createRef();
    this.anasayfa_104013_value_kuikaTableRef = React.createRef();
    this.anasayfa_530498_value_kuikaTableRef = React.createRef();
    this.anasayfa_87951_value_kuikaTableRef = React.createRef();
    this.anasayfa_34385_value_kuikaGalleryViewRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      SetLanguage: "",
      GetLanguage: "",
      GetParametreler: [],
      GetKullanici: [],
      ReadFromSessionStorage: "",
      GetCariBilgileri: [],
      GetToplamTeklifSepeti: [],
      GetToplamSiparisSepetUrunSayisi: [],
      GetYeniUrunler: [],
      GetCariParaBirimi: [],
      Top5SiparisDesc: [],
      Top5Teklif: [],
      ToplamSiparisSayisi: [],
      ToplamTeklifSayisi: [],
      ToplamRevizeBekleyenTeklif: [],
      ToplamOnayBekleyenTeklifler: [],
      SepetteBekleyen5Stok: [],
      CariEkstreToplam: [],
      GetKampanyaliUrunler: [],
      IfThenElse: false,
      isComp692983Visible: "hidden",
      isComp913183Visible: "hidden",
      isComp583090Visible: "hidden",
      isComp469352Visible: "hidden",
      isComp185849Visible: "hidden",
      isComp9628Visible: "hidden",
      isComp610456Visible: "hidden",
      isComp741887Visible: "hidden",
      isComp487899Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("anasayfa", "blank_screen");
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.AnaSayfaPageInit();
    } else if (this.context?.isMasterPageInitLoaded) {
      this._prevMasterPageInitLoaded = true;
      await this.AnaSayfaPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("anasayfa", "blank_screen");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("anasayfa", "blank_screen");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.AnaSayfaPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.AnaSayfaPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  AnaSayfaPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GetLanguage = await ReactSystemFunctions.getLanguage(
      this.ml,
      this.defaultML
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AnaSayfaPageInit1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  AnaSayfaPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      currentUsername_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "AnaSayfa/AnaSayfaPageInit1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetParametreler = result?.data.getParametreler;
    stateVars.isComp692983Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp583090Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp469352Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp610456Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp487899Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GetKullanici = result?.data.getKullanici;
    formVars.anasayfa_683174_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetKullanici !== undefined
        ? stateVars.GetKullanici?.length > 0
          ? stateVars.GetKullanici[0].adSoyad
          : null
        : this.state.GetKullanici?.length > 0
        ? this.state.GetKullanici[0].adSoyad
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AnaSayfaPageInit2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AnaSayfaPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("CariKod", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AnaSayfaPageInit3_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  AnaSayfaPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      isPlasiyer_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isPlasiyer
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isPlasiyer
            : null
        ),
        "boolean"
      ),
      PlasiyerCariKod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.ReadFromSessionStorage),
        "string"
      ),
      CariKod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].musteriKodu
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].musteriKodu
            : null
        ),
        "string"
      ),
      FirmaKodu_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      FirmaKodu_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      tip_3: ReactSystemFunctions.convertToTypeByName(0, "number"),
      FiyatGrubu_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].fiyatgrubu
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].fiyatgrubu
            : null
        ),
        "string"
      ),
      CariKodu_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      ListeFiyati_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].listE_FIATI
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].listE_FIATI
            : null
        ),
        "string"
      ),
      dil_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.GetLanguage),
        "string"
      ),
      paraBirimi_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].parabirimi
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].parabirimi
            : null
        ),
        "number"
      ),
      FirmaKodu_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      FirmaKodu_6: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      FirmaKodu_7: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      FirmaKodu_8: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      FirmaKodu_9: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      FirmaKodu_10: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      cariKod_11: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      isYurtici_12: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        "number"
      ),
      CariKod_12: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      paraBirimi_13: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].parabirimi
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].parabirimi
            : null
        ),
        "number"
      ),
      CariKod_14: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      dil_14: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.GetLanguage),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "AnaSayfa/AnaSayfaPageInit3_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetCariBilgileri = result?.data.getCariBilgileri;
    stateVars.GetToplamTeklifSepeti = result?.data.getToplamTeklifSepeti;
    formVars.anasayfa_30105_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamTeklifSepeti !== undefined
        ? stateVars.GetToplamTeklifSepeti?.length > 0
          ? stateVars.GetToplamTeklifSepeti[0].toplamTeklifSepeti
          : null
        : this.state.GetToplamTeklifSepeti?.length > 0
        ? this.state.GetToplamTeklifSepeti[0].toplamTeklifSepeti
        : null
    );
    stateVars.GetToplamSiparisSepetUrunSayisi =
      result?.data.getToplamSiparisSepetUrunSayisi;
    formVars.anasayfa_21550_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamSiparisSepetUrunSayisi !== undefined
        ? stateVars.GetToplamSiparisSepetUrunSayisi?.length > 0
          ? stateVars.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
          : null
        : this.state.GetToplamSiparisSepetUrunSayisi?.length > 0
        ? this.state.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
        : null
    );
    stateVars.GetYeniUrunler = result?.data.getYeniUrunler;

    stateVars.GetCariParaBirimi = result?.data.getCariParaBirimi;
    formVars.anasayfa_756076_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );
    stateVars.Top5SiparisDesc = result?.data.top5SiparisDesc;

    stateVars.Top5Teklif = result?.data.top5Teklif;

    stateVars.ToplamSiparisSayisi = result?.data.toplamSiparisSayisi;
    formVars.anasayfa_642068_value = ReactSystemFunctions.toString(
      this,
      stateVars.ToplamSiparisSayisi !== undefined
        ? stateVars.ToplamSiparisSayisi?.length > 0
          ? stateVars.ToplamSiparisSayisi[0].toplamSiparis
          : null
        : this.state.ToplamSiparisSayisi?.length > 0
        ? this.state.ToplamSiparisSayisi[0].toplamSiparis
        : null
    );
    stateVars.ToplamTeklifSayisi = result?.data.toplamTeklifSayisi;
    formVars.anasayfa_964860_value = ReactSystemFunctions.toString(
      this,
      stateVars.ToplamTeklifSayisi !== undefined
        ? stateVars.ToplamTeklifSayisi?.length > 0
          ? stateVars.ToplamTeklifSayisi[0].toplamTeklif
          : null
        : this.state.ToplamTeklifSayisi?.length > 0
        ? this.state.ToplamTeklifSayisi[0].toplamTeklif
        : null
    );
    stateVars.ToplamRevizeBekleyenTeklif =
      result?.data.toplamRevizeBekleyenTeklif;
    formVars.anasayfa_105818_value = ReactSystemFunctions.toString(
      this,
      stateVars.ToplamRevizeBekleyenTeklif !== undefined
        ? stateVars.ToplamRevizeBekleyenTeklif?.length > 0
          ? stateVars.ToplamRevizeBekleyenTeklif[0].toplamTeklif
          : null
        : this.state.ToplamRevizeBekleyenTeklif?.length > 0
        ? this.state.ToplamRevizeBekleyenTeklif[0].toplamTeklif
        : null
    );
    stateVars.ToplamOnayBekleyenTeklifler =
      result?.data.toplamOnayBekleyenTeklifler;
    formVars.anasayfa_242304_value = ReactSystemFunctions.toString(
      this,
      stateVars.ToplamOnayBekleyenTeklifler !== undefined
        ? stateVars.ToplamOnayBekleyenTeklifler?.length > 0
          ? stateVars.ToplamOnayBekleyenTeklifler[0].toplamTeklif
          : null
        : this.state.ToplamOnayBekleyenTeklifler?.length > 0
        ? this.state.ToplamOnayBekleyenTeklifler[0].toplamTeklif
        : null
    );
    stateVars.SepetteBekleyen5Stok = result?.data.sepetteBekleyen5Stok;

    stateVars.CariEkstreToplam = result?.data.cariEkstreToplam;
    formVars.anasayfa_736604_value = ReactSystemFunctions.toString(
      this,
      stateVars.CariEkstreToplam !== undefined
        ? stateVars.CariEkstreToplam?.length > 0
          ? stateVars.CariEkstreToplam[0].bakiye
          : null
        : this.state.CariEkstreToplam?.length > 0
        ? this.state.CariEkstreToplam[0].bakiye
        : null
    );
    stateVars.GetCariParaBirimi = result?.data.getCariParaBirimi;
    formVars.anasayfa_756076_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );
    stateVars.GetKampanyaliUrunler = result?.data.getKampanyaliUrunler;

    stateVars.isComp913183Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKampanyaliUrunler !== undefined
            ? stateVars.GetKampanyaliUrunler?.length > 0
              ? stateVars.GetKampanyaliUrunler[0].stoK_ADI
              : null
            : this.state.GetKampanyaliUrunler?.length > 0
            ? this.state.GetKampanyaliUrunler[0].stoK_ADI
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AnaSayfaPageInit4_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AnaSayfaPageInit4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.anasayfa_30105_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamTeklifSepeti !== undefined
        ? stateVars.GetToplamTeklifSepeti?.length > 0
          ? stateVars.GetToplamTeklifSepeti[0].toplamTeklifSepeti
          : null
        : this.state.GetToplamTeklifSepeti?.length > 0
        ? this.state.GetToplamTeklifSepeti[0].toplamTeklifSepeti
        : null
    );

    stateVars.isComp692983Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.anasayfa_21550_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamSiparisSepetUrunSayisi !== undefined
        ? stateVars.GetToplamSiparisSepetUrunSayisi?.length > 0
          ? stateVars.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
          : null
        : this.state.GetToplamSiparisSepetUrunSayisi?.length > 0
        ? this.state.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
        : null
    );

    formVars.anasayfa_683174_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetKullanici !== undefined
        ? stateVars.GetKullanici?.length > 0
          ? stateVars.GetKullanici[0].adSoyad
          : null
        : this.state.GetKullanici?.length > 0
        ? this.state.GetKullanici[0].adSoyad
        : null
    );

    formVars.anasayfa_102679_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBilgileri !== undefined
        ? stateVars.GetCariBilgileri?.length > 0
          ? stateVars.GetCariBilgileri[0].carI_ISIM
          : null
        : this.state.GetCariBilgileri?.length > 0
        ? this.state.GetCariBilgileri[0].carI_ISIM
        : null
    );

    formVars.anasayfa_642068_value = ReactSystemFunctions.toString(
      this,
      stateVars.ToplamSiparisSayisi !== undefined
        ? stateVars.ToplamSiparisSayisi?.length > 0
          ? stateVars.ToplamSiparisSayisi[0].toplamSiparis
          : null
        : this.state.ToplamSiparisSayisi?.length > 0
        ? this.state.ToplamSiparisSayisi[0].toplamSiparis
        : null
    );

    formVars.anasayfa_756076_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );

    formVars.anasayfa_736604_value = ReactSystemFunctions.toString(
      this,
      stateVars.CariEkstreToplam !== undefined
        ? stateVars.CariEkstreToplam?.length > 0
          ? stateVars.CariEkstreToplam[0].bakiye
          : null
        : this.state.CariEkstreToplam?.length > 0
        ? this.state.CariEkstreToplam[0].bakiye
        : null
    );

    stateVars.dataSource_745370 =
      stateVars.GetKampanyaliUrunler ?? this.state.GetKampanyaliUrunler;
    stateVars.isComp913183Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKampanyaliUrunler !== undefined
            ? stateVars.GetKampanyaliUrunler?.length > 0
              ? stateVars.GetKampanyaliUrunler[0].stoK_ADI
              : null
            : this.state.GetKampanyaliUrunler?.length > 0
            ? this.state.GetKampanyaliUrunler[0].stoK_ADI
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp583090Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp469352Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.anasayfa_964860_value = ReactSystemFunctions.toString(
      this,
      stateVars.ToplamTeklifSayisi !== undefined
        ? stateVars.ToplamTeklifSayisi?.length > 0
          ? stateVars.ToplamTeklifSayisi[0].toplamTeklif
          : null
        : this.state.ToplamTeklifSayisi?.length > 0
        ? this.state.ToplamTeklifSayisi[0].toplamTeklif
        : null
    );

    formVars.anasayfa_105818_value = ReactSystemFunctions.toString(
      this,
      stateVars.ToplamRevizeBekleyenTeklif !== undefined
        ? stateVars.ToplamRevizeBekleyenTeklif?.length > 0
          ? stateVars.ToplamRevizeBekleyenTeklif[0].toplamTeklif
          : null
        : this.state.ToplamRevizeBekleyenTeklif?.length > 0
        ? this.state.ToplamRevizeBekleyenTeklif[0].toplamTeklif
        : null
    );

    formVars.anasayfa_242304_value = ReactSystemFunctions.toString(
      this,
      stateVars.ToplamOnayBekleyenTeklifler !== undefined
        ? stateVars.ToplamOnayBekleyenTeklifler?.length > 0
          ? stateVars.ToplamOnayBekleyenTeklifler[0].toplamTeklif
          : null
        : this.state.ToplamOnayBekleyenTeklifler?.length > 0
        ? this.state.ToplamOnayBekleyenTeklifler[0].toplamTeklif
        : null
    );

    stateVars.dataSource_104013 =
      stateVars.Top5SiparisDesc ?? this.state.Top5SiparisDesc;
    stateVars.isComp185849Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "anasayfa_104013_value",
          "siparisDurum"
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp9628Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          "anasayfa_104013_value",
          "siparisDurum"
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_530498 =
      stateVars.SepetteBekleyen5Stok ?? this.state.SepetteBekleyen5Stok;
    stateVars.isComp610456Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_87951 = stateVars.Top5Teklif ?? this.state.Top5Teklif;

    stateVars.dataSource_34385 =
      stateVars.GetYeniUrunler ?? this.state.GetYeniUrunler;
    formVars.anasayfa_351328_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );

    stateVars.isComp741887Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "anasayfa_34385_value",
          "adetBazliFiyatVarMi"
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";

    stateVars.isComp487899Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  AnaSayfaComponent_317000_onPressEnter = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/arama") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "Arama",
      "Ara",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfa_317000_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "AnaSayfa",
      "Arama",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnaSayfaComponent_692983_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/teklifolustur") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "AnaSayfa",
      "TeklifOlustur",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnaSayfaComponent_971668_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "SiparisSepetOzet",
      "FirmaKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisSepetOzet",
      "paraBirimi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].parabirimi
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].parabirimi
            : null
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "AnaSayfa",
      "SiparisSepetOzet",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "222082",
      null,
      "right",
      "true",
      "380px",
      "100vh",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnaSayfaComponent_733891_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("tr_TR", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnaSayfaComponent_117303_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("en_US", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnaSayfaComponent_852364_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("es_ES", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnaSayfaComponent_55820_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("fr_FR", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnaSayfaComponent_404060_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/profil") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "AnaSayfa",
      "Profil",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnaSayfaComponent_796691_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/siparisdurumlari") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "AnaSayfa",
      "SiparisDurumlari",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnaSayfaComponent_242927_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/carihesap") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "AnaSayfa",
      "CariHesap",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnaSayfaComponent_554333_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "StokKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "anasayfa_745370_value", "stoK_KODU"),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "listeFiat",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].listE_FIATI
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].listE_FIATI
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "FiatGrup",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].fiyatgrubu
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].fiyatgrubu
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "paraBirimi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariParaBirimi !== undefined
            ? stateVars.GetCariParaBirimi?.length > 0
              ? stateVars.GetCariParaBirimi[0].paraSembol
              : null
            : this.state.GetCariParaBirimi?.length > 0
            ? this.state.GetCariParaBirimi[0].paraSembol
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "Kod3",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "anasayfa_745370_value", "koD_3"),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "MusteriMarka",
      ReactSystemFunctions.convertToTypeByName("", "string")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "AnaSayfa",
      "prooductDetail",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "769765",
      null,
      "top",
      "true",
      "380px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnaSayfaComponent_294677_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/siparisdurumlari") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "AnaSayfa",
      "SiparisDurumlari",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnaSayfaComponent_175967_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "SiparisDetay",
      "CariKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "anasayfa_104013_value", "firmaKodu"),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisDetay",
      "SiparisNumarasi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "anasayfa_104013_value",
          "siparisNumarasi"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisDetay",
      "ParaSembol",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "anasayfa_104013_value", "paraSembol"),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisDetay",
      "SiparisDurumu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "anasayfa_104013_value",
          "siparisDurum"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisDetay",
      "Kullanici",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "anasayfa_104013_value", "adSoyad"),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisDetay",
      "Tarih",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "anasayfa_104013_value",
          "siparisTarihi"
        ),
        "Date"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisDetay",
      "not",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "anasayfa_104013_value", "siparisNot"),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisDetay",
      "OdemeTip",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "anasayfa_104013_value", "odemeTipi"),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisDetay",
      "TalepNo",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "anasayfa_104013_value", "talepNo"),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisDetay",
      "ToplamTutar",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "anasayfa_104013_value",
          "toplamTutar"
        ),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisDetay",
      "Iskonto",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "anasayfa_104013_value",
          "iskontoToplami"
        ),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisDetay",
      "NetTutar",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "anasayfa_104013_value", "netTutar"),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisDetay",
      "Kdv",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "anasayfa_104013_value", "kdvTutari"),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisDetay",
      "genelToplam",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "anasayfa_104013_value",
          "genelToplam"
        ),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisDetay",
      "netsisSipNo",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "anasayfa_104013_value",
          "netsisSiparisNo"
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "AnaSayfa",
      "SiparisDetay",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "480976",
      null,
      "top",
      "true",
      "380px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnaSayfaComponent_134673_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/siparisolustur") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "AnaSayfa",
      "SiparisOlustur",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnaSayfaComponent_49717_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/yeniurunler") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "AnaSayfa",
      "YeniUrunler",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnaSayfaComponent_655743_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "StokKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "anasayfa_34385_value", "stoK_KODU"),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "listeFiat",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].listE_FIATI
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].listE_FIATI
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "FiatGrup",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].fiyatgrubu
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].fiyatgrubu
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "paraBirimi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariParaBirimi !== undefined
            ? stateVars.GetCariParaBirimi?.length > 0
              ? stateVars.GetCariParaBirimi[0].paraSembol
              : null
            : this.state.GetCariParaBirimi?.length > 0
            ? this.state.GetCariParaBirimi[0].paraSembol
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "Kod3",
      ReactSystemFunctions.convertToTypeByName(null, "string")
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "MusteriMarka",
      ReactSystemFunctions.convertToTypeByName("VADEN", "string")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "AnaSayfa",
      "prooductDetail",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "456055",
      null,
      "top",
      "true",
      "380px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnaSayfaComponent_487899_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "cariKod",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "BirimFiyat",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "anasayfa_34385_value", "fiyat"),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "KulID",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].id
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].id
            : null
        ),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "StokKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "anasayfa_34385_value", "stoK_KODU"),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "PlasiyerMi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isPlasiyer
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isPlasiyer
            : null
        ),
        "boolean"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "KdvOrani",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "anasayfa_34385_value", "kdV_ORANI"),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "StokAdi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "anasayfa_34385_value", "stoK_ADI"),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "isSiparis",
      ReactSystemFunctions.convertToTypeByName(false, "boolean")
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "isYurtici",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        "boolean"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "AnaSayfa",
      "SepetModal",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "234173",
      null,
      null,
      "true",
      "400px",
      "38vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnaSayfaComponent_995804_onClick_if0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "d6cae65c_cef1_9a30_d855_453e36e1a0f4_notify",
        this.defaultML,
        "Fiyatı olmayan ürünü sepete ekleyemezsiniz"
      ),
      ReactSystemFunctions.convertToTypeByName("warning", "string"),
      ReactSystemFunctions.convertToTypeByName("top-center", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("#212121", "string"),
      ReactSystemFunctions.convertToTypeByName("#ffffff", "string"),
      14
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  AnaSayfaComponent_995804_onClick_else0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "cariKod",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "BirimFiyat",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "anasayfa_34385_value", "fiyat"),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "KulID",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].id
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].id
            : null
        ),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "StokKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "anasayfa_34385_value", "stoK_KODU"),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "PlasiyerMi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isPlasiyer
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isPlasiyer
            : null
        ),
        "boolean"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "KdvOrani",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "anasayfa_34385_value", "kdV_ORANI"),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "StokAdi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "anasayfa_34385_value", "stoK_ADI"),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "isSiparis",
      ReactSystemFunctions.convertToTypeByName(true, "boolean")
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "isYurtici",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        "boolean"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "AnaSayfa",
      "SepetModal",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "660300",
      null,
      null,
      "true",
      "400px",
      "38vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  AnaSayfaComponent_995804_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, "anasayfa_34385_value", "fiyat"),
        "0"
      )
    ) {
      isErrorOccurred = await this.AnaSayfaComponent_995804_onClick_if0();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.AnaSayfaComponent_995804_onClick_else0();
      if (isErrorOccurred) return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnaSayfaComponent_289790_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [
      ,
      ,
      ,
      ,
      ,
      769765,
      ,
      480976,
      ,
      ,
      456055,
      234173,
      660300,
    ] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.AnaSayfaPageInit();
    }
  }
}
